export enum WidgetType {
  FASTAG = 'fastag',
  PUC_WIDGET = 'pucWidget',
  RTO_VEHICLE_INFO_WIDGET = 'rtoVehicleInfo',
  RTO_DETAIL_WIDGET = 'rtoDetail',
  FASTAG_ACKODRIVE = 'fastagAckoDrive',
  PUC_WIDGET_ACKODRIVE = 'pucWidgetAckoDrive',
  RTO_VEHICLE_INFO_WIDGET_ACKODRIVE = 'rtoVehicleInfoAckoDrive',
  RTO_DETAIL_ACKODRIVE = 'rtoDetailWidgetAckoDrive',
  CHALLAN_WIDGET = 'challanWidget',
  CHALLAN_WIDGET_ACKODRIVE = 'challanWidgetAckoDrive',
  CHALLAN_WIDGET_LANDING = 'challan-widget-landing-page',
  RTO_WIDGET = 'RTOWidget',
}
